import React from 'react';
import {Message_Internal_Panel, RootInternalDialog} from "../../../index";

const Message_Internal_Dialog = React.memo(({
                                                recordId,
                                                open,
                                                asDrawer = false,
                                                onHide,
                                            }) => {
    const TAG = "Message_Internal_Dialog";
    return (<>
            <RootInternalDialog
                open={open}
                title={"Message Details"}
                onHide={onHide}
                asDrawer={asDrawer}
                md={6}>
                <Message_Internal_Panel
                    recordId={recordId}
                    justifyAt={'center'}
                />
            </RootInternalDialog>
        </>
    )
});
export default Message_Internal_Dialog;
